import * as React from 'react';
import { useState, useEffect } from "react"
import { ArrowRightOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from "react-redux"
import FuelConsuptionsComponent from "./FuelConsuptionsComponent"
import GeneralDetailsComponent from "./GeneralDetailsComponent"
import OffHireDataComponent from "./OffHireDataComponent"
import { fetchOffHireData, fetchVoyages } from '../../features/Voyage/VoyageSlice';

import '../../css/offhiremodal.css';


const VoyageRow = ({ voyage, onSelect }) => {

    const [category, setCategory] = useState("General Details")
    const {page, selectedVoyage, voyagesWholeData } = useSelector((state) => state.voyage);
    const dispatch = useDispatch()

    const renderComponent = () => {
        switch (category) {
            case 'General Details':
                return <GeneralDetailsComponent data={voyage} />;
            case 'Fuel Consumptions':
                
                return <FuelConsuptionsComponent data={voyagesWholeData[selectedVoyage?.casper_id]?.fuel} />;

            case 'Off Hire Data':
                return <OffHireDataComponent voyageData={voyage} />;
            default:
                return null;
        }
    };


    const fetchVoyageData = (tab) => {
        if(tab === "") {
            return;
        }
        const params = {
            casper_id: selectedVoyage?.casper_id,
            requested_tab: tab,
            page: 1
        }
        dispatch(fetchVoyages(params));
    }

    useEffect(() => {
        setCategory("General Details")
    }, [selectedVoyage])


    return (
        <div className="voyageRowCard" onClick={onSelect}>
            <div className="voyageRow" id={selectedVoyage?.imo_number === voyage?.imo_number ? "card-active" : ""}>
                <div className="voyageRowElem1">
                    <div className="voyageRowElem1-Children">
                        <div className="voyageRowElem1-Children-second-Element1">
                            <span className="vessel-data-label">Vessel Name </span>
                            <span className="vessel-data-data">{voyage?.vessel_name} ({voyage?.imo_number})</span>
                        </div>
                        <div className="voyageRowElem1-Children-Element1" style={{width:"60%", height:'100%', justifyContent:"flex-start"}}>
                            <span className="vessel-data-label">Casper ID</span>
                            <span className="vessel-data-data">{voyage?.casper_id}</span>
                        </div>
                    </div>
                    <div className="voyageRowElem1-Children-second">
                        <div className="voyageRowElem1-Children-Element1">
                            <span className="vessel-data-label">Departure</span>
                            <span className="vessel-data-data">{voyage?.from_port || '-'}</span>
                        </div>
                        <div className={voyage?.voyage_status === "completed" ? '' : 'voyage-arrow-colored'}>
                            <ArrowRightOutlined />
                        </div>
                        <div className="voyageRowElem1-Children-Element1">
                            <span className="vessel-data-label">Arrival</span>
                            <span className="vessel-data-data">{voyage?.to_port || '-'}</span>
                        </div>
                    </div>
                </div>

                <div className="voyageRowElem2">
                    <div className="voyageRowElem2-Heading">
                        <span
                            onClick={ () => {fetchVoyageData(""); setCategory('General Details'); }}
                            className={category === 'General Details' ? 'active-tab' : ''}
                        >
                            General Details
                        </span>
                        <span
                            onClick={() => { fetchVoyageData("fuel"); setCategory('Fuel Consumptions'); }} // Fetch fuel data
                            className={category === 'Fuel Consumptions' ? 'active-tab' : ''}
                        >
                            Fuel Consumptions
                        </span>
                        <span
                            onClick={() => { fetchVoyageData("offhire"); setCategory('Off Hire Data'); }}
                            className={category === 'Off Hire Data' ? 'active-tab' : ''}
                        >
                            Off Hire Data
                        </span>
                    </div>
                    <div className="voyageRowElem2-VoyageData">
                        {renderComponent()}
                    </div>
                </div>

            </div>


        </div>
    )
}

export default VoyageRow